export default function generateColorShades(
  baseColor: string
): Record<number, string> {
  // Ensure baseColor is in correct format
  if (!baseColor.startsWith('#')) {
    baseColor = '#' + baseColor
  }

  // Parse the base color to RGB
  const r = parseInt(baseColor.slice(1, 3), 16)
  const g = parseInt(baseColor.slice(3, 5), 16)
  const b = parseInt(baseColor.slice(5, 7), 16)

  const result: Record<number, string> = {}
  result[400] = baseColor // Main color at position 400

  // Define shade positions
  const positions = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]

  // Generate lighter shades (50-300)
  for (const pos of positions.filter((p) => p < 400)) {
    // Calculate how much to lighten (1.0 = white, 0.0 = original color)
    const lightFactor = (400 - pos) / 400

    // Calculate new RGB values blending toward white
    const newR = Math.round(r + (255 - r) * lightFactor)
    const newG = Math.round(g + (255 - g) * lightFactor)
    const newB = Math.round(b + (255 - b) * lightFactor)

    // Convert to hex
    const hexR = newR.toString(16).padStart(2, '0')
    const hexG = newG.toString(16).padStart(2, '0')
    const hexB = newB.toString(16).padStart(2, '0')

    result[pos] = `#${hexR}${hexG}${hexB}`
  }

  // Generate darker shades (500-950)
  for (const pos of positions.filter((p) => p > 400)) {
    // Calculate how much to darken (0.0 = original color, 1.0 = black)
    const darkFactor = (pos - 400) / 550 // 950-400 = 550 (max range)

    // Calculate new RGB values blending toward black
    const newR = Math.round(r * (1 - darkFactor))
    const newG = Math.round(g * (1 - darkFactor))
    const newB = Math.round(b * (1 - darkFactor))

    // Convert to hex
    const hexR = newR.toString(16).padStart(2, '0')
    const hexG = newG.toString(16).padStart(2, '0')
    const hexB = newB.toString(16).padStart(2, '0')

    result[pos] = `#${hexR}${hexG}${hexB}`
  }

  return result
}

// Example usage:
// const blueShades = generateColorShades("#0088ff");
// console.log(blueShades);
